import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Joyride, { Step } from "react-joyride";

import { usePermissionsModalOpen } from "@/providers/hooks/use-permissions";

import { CustomJoyrideTooltip } from "./custom-Joyride-tooltip";
import { useGuidedTourContext } from "./guided-tour-context";

const getSteps = (t: (key: string) => string): Step[] => [
    {
        target: '[data-tour="brand-selector"]',
        placement: "bottom",
        content: (
            <p>
                <strong>{t("tour_brand_title")}</strong>
                <br />
                {t("tour_brand_text")}
            </p>
        ),
        disableBeacon: true,
    },
    {
        target: '[data-tour="phone-number-selector"]',
        placement: "bottom",
        content: (
            <p>
                <strong>{t("tour_phone_title")}</strong>
                <br />
                {t("tour_phone_text")}
            </p>
        ),
    },
    {
        target: '[data-tour="kpi-area"]',
        placement: "bottom",
        content: (
            <p>
                <strong>{t("tour_kpi_title")}</strong>
                <br />
                {t("tour_kpi_text")}
            </p>
        ),
    },
    {
        target: '[data-tour="profile-avatar"]',
        placement: "top",
        content: (
            <p>
                <strong>{t("tour_profile_title")}</strong>
                <br />
                {t("tour_profile_text")}
            </p>
        ),
    },
    // TODO: Add AI tour when it's ready
    // {
    //     target: '[data-tour="ai-button"]',
    //     placement: "top",
    //     content: (
    //         <p>
    //             <strong>Darwin</strong>
    //             <br />
    //             {t("tour_ai_text")}
    //             <br />
    //             {t("wip_text")}
    //         </p>
    //     ),
    // },
];

export const GuidedTour = () => {
    const { t } = useTranslation();
    const { run, setHasSeenTour } = useGuidedTourContext();
    const [domReady, setDomReady] = useState(false);
    const permissionsModalOpen = usePermissionsModalOpen();

    useEffect(() => {
        // Check if the first tour element is in the DOM
        if (document.querySelector('[data-tour="brand-selector"]')) {
            setDomReady(true);
            return;
        }
        // Repeat the check until the element is found
        const interval = setInterval(() => {
            if (document.querySelector('[data-tour="brand-selector"]')) {
                setDomReady(true);
                clearInterval(interval);
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);

    // Render Joyride only if domReady is true and permissions modal is NOT open
    if (!domReady || permissionsModalOpen) return null;

    return (
        <Joyride
            steps={getSteps(t)}
            run={run}
            continuous
            showSkipButton
            showProgress
            disableScrolling
            disableCloseOnEsc
            disableOverlayClose
            tooltipComponent={CustomJoyrideTooltip}
            styles={{ options: { zIndex: 9999 } }}
            locale={{
                back: t("tour_back"),
                close: t("tour_close"),
                last: t("tour_last"),
                next: t("tour_next"),
                skip: t("tour_skip"),
            }}
            callback={(data) => {
                if (data.status === "finished" || data.status === "skipped") {
                    setHasSeenTour(true);
                }
            }}
        />
    );
};
